<div [formGroup]="fg">
  <div class="action-setting">
    <div class="action-setting-title">
      {{ 'commonActions.addOwnerAction.newOwnerEmail' | labelsProvider }}
    </div>
    <input
      class="action-setting-input"
      formControlName="newOwnerUserEmail"
      type="text"
      placeholder="Enter new owner email"
      [ngClass]="{
        'input-form-invalid':
          fg.controls['newOwnerUserEmail'].invalid &&
          (fg.controls['newOwnerUserEmail'].dirty || fg.controls['newOwnerUserEmail'].touched),
      }"
    />
  </div>
</div>
